import React, { Component } from 'react'
import { Grid } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import CountBarriosSummary from '../SeaLiceStatistic/CountBarriosSummary'
import TotalBarriosSeaLice from '../SeaLiceStatistic/TotalBarriosSeaLice'
import BarriosMap from './BarriosMap'
import WidgetContainer from '../../WidgetContainer'
import messages from '../translate'
import BarriosInfo from '../InfoTable/BarriosInfo'
import Breadcrumbs from '../InfoTable/Breadcrumbs'

class BarriosWidgets extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.activeBarrio && nextProps.activeBarrio) {
      return false
    }

    return true
  }

  renderMapView = () => {
    const {
      intl: { formatMessage },
    } = this.props

    return ifWindowWidthLessThan(992) ? null : (
      <Grid item lg={6} md={12} sm={12} xs={12}>
        <WidgetContainer name={formatMessage(messages.mapView)}>
          <div className="barrios-map">
            <BarriosMap hiddenBarrioTooltip />
          </div>
        </WidgetContainer>
      </Grid>
    )
  }

  render() {
    const {
      activeBarrio,
      intl: { formatMessage },
    } = this.props

    return (
      <div className="my-sites-view">
        {Boolean(activeBarrio) && (
          <Grid container spacing={2} className="sealice-statistic">
            {this.renderMapView()}
            <Grid item lg={6} md={12} sm={12} xs={12}>
              <CountBarriosSummary />
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <TotalBarriosSeaLice unit={formatMessage(messages.barrios)} />
            </Grid>
          </Grid>
        )}
        <WidgetContainer
          name={
            activeBarrio
              ? formatMessage(messages.siteList)
              : formatMessage(messages.barriosList)
          }>
          {Boolean(activeBarrio) && <Breadcrumbs />}
          <BarriosInfo />
        </WidgetContainer>
      </div>
    )
  }
}

export default connect(state => ({
  activeBarrio: state.getIn(['seaLice', 'activeBarrios']),
}))(injectIntl(BarriosWidgets))
